<template>
  <v-container>
    <v-row dense>
      <v-col cols="12" class="pb-3">
        <div class="text-h6">Presiona el Botón para Agregar un Producto que desee Vender Antes de Cosechar o Producir.</div>
      </v-col>
      <v-col v-if="user_can.add" cols="12">
        <v-btn router to="/ru/preparacion" depressed class="primary">
          <v-icon left>mdi-plus</v-icon>
          Agregar Publicación
        </v-btn>
      </v-col>
      <!-- Fila de espaciado -->
       <v-col cols="12" class="py-5"></v-col>
       <!-- Puedes ajustar py-5 a py-3 o py-2 según el espacio que prefieras -->

      <v-col cols="12" class="pb-3">
        <div class="text-h6">Buscar Mis Ventas Inmediatas, Ventas Solicitadas, Pre-Ventas, Ventas Reservadas o Ventas Pactadas</div>
      </v-col>
      <!-- listado de preparaciones en el almacenamiento local -->
      <v-col cols="12">
        <v-list three-line>
          <template v-for="preparacion in preparaciones">
            <form-card
              :key="preparacion.id"
              :bottom-right-text="producerDescription(preparacion.productor)"
              :top-text="`Finca • ${getNombreDeFinca(preparacion.id_finca)}`"
              :top-right-text="preparacion.fecha"
              :middle-text="`Preparación de ${
                cultivo(preparacion.id_cultivo).descripcion
              }`"
              :bottom-text="`Coa ${preparacion.coa} , RUC: ${getRucDeFinca(
                preparacion.id_finca
              )}`"
              :sincronized="preparacion.sincronizado"
              @click="traerRegistroYNavegar(preparacion)"
            />
          </template>
        </v-list>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import { producerDescription } from '@/utilidades'

export default {
  name: 'Preparaciones',
  computed: {
    ...mapState('registros', ['preparaciones']),
    ...mapGetters('listados', ['cultivo']),
    ...mapGetters('registros', ['getNombreDeFinca', 'getRucDeFinca']),
    user_can() {
      return this.$store.getters['auth/userCan'](this.$route.path)
    },
  },
  mounted() {
    this.$store.commit('ui/updateToolbar', 'Venta y Mercado de Abasto Digital')
  },
  methods: {
    producerDescription,
    async traerRegistroYNavegar(registro) {
      if (registro.sincronizado === true) {
        await this.$store.dispatch('registros/getPreparacion', {
          id: registro.id,
        })
      }
      this.$router.push(`/ru/preparacion/${registro.id}`)
    },
  },
}
</script>
